import './sticky.scss';

import Sticky from './Sticky';

export default Sticky;
